<template>
  <div class="footer-main">
    <div class="footer-main">
      <div class="item" style="padding-right: 260px">
        <img src="../assets/address.svg" width="20" style="padding-right: 10px" />
        <div>
          {{
            lang == "EN"
              ? "地址：安徽省合肥市经济技术开发区海恒社区繁华大道8639号繁华大厦2206室"
              : "Address: Room 1708, Building B, Classic Plaza, Fanhua Avenue, Jingkai District, Hefei"
          }}
        </div>
      </div>

      <div class="item">
        <div class="item" style="padding-right: 20px">
          <img src="../assets/phone.svg" height="15" style="padding-right: 10px" />
          <div>
            {{ lang == "EN" ? "电话：0551-63814683" : "phone：0551-63814683" }}
          </div>
        </div>
        <div class="item">
          <img src="../assets/email.svg" height="15" style="padding-right: 10px" />
          <div>{{ lang == "EN" ? "邮箱" : "email" }}：medisets@ahmds.com</div>
        </div>
      </div>
      <img src="../assets/qr_code.jpg" width="110" class="qr-code" />
    </div>
    <div class="item" href="https://beian.miit.gov.cn/">
      <a
        style="cursor: pointer; color: #fff; text-decoration: none"
        href="https://beian.miit.gov.cn/"
      >
        版权所有脉律臣道（合肥）医学科技有限公司 皖ICP备2021000041号 Copyright © 2021
        MDS(Hefei) lnc. All Rights Reserved
      </a>
      <a
        style="
          cursor: pointer;
          color: #fff;
          text-decoration: none;
          margin-left: 40px;
          display: flex;
          align-items: center;
        "
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34019102000871"
      >
        <img src="../assets/ga.png" style="margin-right: 10px" height="20" />
        皖公网安备 34019102000871号
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["lang"],
};
</script>
<style scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 100px;
}

.footer-main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.qr-code {
  position: absolute;
  right: 200px;
}
</style>
